<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'home' })"
          v-tooltip="$t('back')"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('homework.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <div>
        <ts-card>
          <div class="overflow-auto">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
              :rowGroup="{
                field: 'homework_date'
              }"
            >
              <template v-slot="{ record }">
                <td>{{ record.teacher_name }}</td>
                <td>{{ record.class_name }}</td>
                <td>{{ record.subject_name }}</td>
                <td>{{ record.remarks }}</td>
                <td>
                  <span class="label label-success" v-if="record.is_sent">{{
                    $t('home.sent')
                  }}</span>
                  <span class="label label-info" v-else>{{
                    $t('home.Pending')
                  }}</span>
                </td>
                <td>{{ record.sent_date }}</td>
                <td class="text-left ts-whitespace-no-wrap">
                  <a-switch
                    size="small"
                    :checked="record.status_open"
                    @change="closeOpen(record)"
                    :loading="homework_status_loading"
                  />
                  <a
                    href="#"
                    class="text-primary ml-2"
                    @click.prevent="edit(record)"
                    v-tooltip="$t('edit')"
                  >
                    <a-icon type="edit" />
                  </a>
                  <a
                    href="#"
                    class="ml-2 text-info"
                    v-tooltip="$t('homework.comment')"
                    @click.prevent="onComment(record)"
                  >
                    <i class="far fa-comment-dots"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <div class="d-flex justify-content-end p-15">
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'homeworkLinkFromHome',
  data() {
    return {
      loading: false,
      homework_status_loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('home/staffHomeworkLinkFromHome', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('homework.teacher') },
        { name: this.$t('homework.class') },
        { name: this.$t('homework.subject') },
        { name: this.$t('homework.remark') },
        { name: this.$t('homework.notification') },
        { name: this.$t('homework.sendDate') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/staffHomeworkLinkFromHome/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(() => {
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('eschool/staffHomework/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'homework-edit',
        params: { id: record.homework_id }
      })
    },
    closeOpen(record) {
      this.homework_status_loading = true
      this.$store
        .dispatch('eschool/staffHomework/changeStatus', {
          id: record.homework_id,
          data: {
            homework_status_id: record.homework_status_id
          }
        })
        .then(() => {
          record.status_open = record.status_open ? false : true
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.homework_status_loading = false
        })
    },
    onComment(record) {
      this.$router.push({
        name: 'homework-comment-public',
        params: { id: record.homework_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('home/staffHomeworkLinkFromHome/RESET_STATE')
    this.$store.commit('home/staffHomework/RESET_STATE')
    this.$store.commit('home/staffHomework/RESET_STATE')
    this.$store.commit('home/staffMyRequest/RESET_STATE')
    this.$store.commit('home/staffMyApproval/RESET_STATE')
    this.$store.commit('home/staffHomework/SET_TEACHER_ID', null)
    this.$store.commit('home/staffHomework/SET_HOMEWORK_STATUS', null)
    this.$store.commit(
      'home/staffHomeworkLinkFromHome/SET_HOMEWORK_STATUS_ID',
      null
    )
    this.$store.commit(
      'home/staffHomeworkLinkFromHome/SET_HOMEWORK_STATUS',
      null
    )
    this.$store.commit('home/staffHomeworkLinkFromHome/SET_SUBJECT_ID', null)
    this.$store.commit('home/staffHomeworkLinkFromHome/SET_CLASS_ID', null)
    this.$store.commit('home/staffHomeworkLinkFromHome/SET_TEACHER_ID', null)
    next()
  }
}
</script>
